<template>
  <b-row>
    <b-col cols="12">
      <router-link :to="{ name: 'EXABCustomFieldsList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
    </b-col>
    <b-col cols="12">
      <b-card>
        <Form
          @submit="onSendForm($event)"
          :values="item"
          :violations="violations"/>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Create',
  components: {
    Form
  },
  data () {
    return {
      item: {
        label: '',
        tooltip: '',
        customFieldType: 1,
        display: 1,
        orderCustomField: 1,
        required: 1,
        showOnExternalForm: 1,
        showOnAgreement: 1,
        customFieldValues: []
      }
    }
  },
  watch: {
    created (val) {
      if (val && this.$route.name === 'EXABCustomFieldsCreate') {
        this.$router.push({ name: 'EXABCustomFieldsList' })
      }
    }
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABCustomFieldsCreate')
  },
  beforeDestroy () {
    this.reset()
  },
  computed: {
    ...mapGetters({
      created: 'customfields/create/created',
      violations: 'customfields/create/violations',
      isLoading: 'customfields/create/isLoading'
    })
  },
  methods: {
    onSendForm (item) {
      this.create(item)
    },
    ...mapActions({
      create: 'customfields/create/create',
      reset: 'customfields/create/reset'
    })
  }
}
</script>

<style scoped>

</style>
